import moment from 'moment-timezone';

const localTimeZone = 'America/Los_Angeles';

export const DaycareDiscountCalculator = (bookingData, serviceDetails, user) => {
  // Defaults
  const basePricePerDay =
    serviceDetails && serviceDetails.daycare ? serviceDetails.daycare[0].price : 50;
  const basePriceForWalk =
    serviceDetails && serviceDetails.walk ? serviceDetails.walk[0].price : 20;

  // Selected pets
  var selectedPets = bookingData && bookingData.selectedPets ? bookingData.selectedPets : [];
  var numberOfPets = selectedPets.length;

  // Days
  var numberOfDays = calculateNumberOfDays(bookingData.dateRange);

  var total = 0;          // with credits/discounts applied
  var originalTotal = 0;  // rack rate with no credits

  // 🟢 Get user bundle info (if active)
  var bundleRemaining = 0;
  if (user && Array.isArray(user.daycareBundle) && user.daycareBundle.length > 0) {
    var activeBundle = user.daycareBundle.find(function (b) {
      return b.status === 'active';
    });
    if (activeBundle) {
      bundleRemaining = activeBundle.remainingDays || 0;
    }
  }

  // 🐾 Calculate total charge per pet
  if (numberOfPets >= 1) {
    for (var i = 0; i < selectedPets.length; i++) {
      var pet = selectedPets[i];

      // Determine per-pet daycare rate (cats are $20 less)
      var isCat = pet && pet.petType === 'Cat';
      var petRate = isCat ? basePricePerDay - 20 : basePricePerDay;
      if (petRate < 0) petRate = 0;

      // Membership credits (if any)
      var petMembership =
        pet && pet.petMembership && Array.isArray(pet.petMembership)
          ? pet.petMembership
          : [];
      var daycareRemaining = 0;
      if (petMembership.length > 0) {
        var first = petMembership[0];
        daycareRemaining =
          first && typeof first.daycareRemaining === 'number'
            ? first.daycareRemaining
            : 0;
      }

      // 🟩 Combine credits + bundle days
      var totalCredits = daycareRemaining + bundleRemaining;

      // Chargeable days (after using credits)
      var chargeableDays = numberOfDays - totalCredits;
      if (chargeableDays < 0) chargeableDays = 0;

      // Totals
      total += petRate * chargeableDays;              // only pay for uncovered days
      originalTotal += petRate * numberOfDays;        // full rack for comparison
    }
  }

  // 🍽️ Food pricing (applies to all selected pets)
  var foodCost = 0;
  if (bookingData && bookingData.foodPreference === 'premium') {
    foodCost = 10;
  } else if (bookingData && bookingData.foodPreference === 'basic') {
    foodCost = 0;
  }
  total += foodCost * numberOfDays * numberOfPets;
  originalTotal += foodCost * numberOfDays * numberOfPets;

  // 🚶 Walk add-on (per pet per day)
  var add = bookingData && bookingData.additionalServices ? bookingData.additionalServices : null;
  if (add && add.walk) {
    var walkServiceCost = basePriceForWalk * numberOfPets * numberOfDays;
    total += walkServiceCost;
    originalTotal += walkServiceCost;
  }

  return { originalPrice: originalTotal, discountedPrice: total };
};

// Calculate days inclusive of start and end in local timezone
function calculateNumberOfDays(dateRange) {
  if (Array.isArray(dateRange) && dateRange.length === 2) {
    var startDate = moment.tz(dateRange[0], localTimeZone).startOf('day');
    var endDate = moment.tz(dateRange[1], localTimeZone).startOf('day');
    var numberOfDays = endDate.diff(startDate, 'days') + 1;
    if (numberOfDays < 0) numberOfDays = 0;
    return numberOfDays;
  }
  return 0;
}

export default DaycareDiscountCalculator;